import { AuthForm } from "../components/auth/AuthForm";

export function SignupPage() {
  return <AuthForm mode="signup" />;
}
